const ArrowBackIcon = () => (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6462 8.04132C17.9513 8.34642 17.9513 8.84108 17.6462 9.14618C17.375 9.41738 16.954 9.44751 16.6495 9.23658L16.5413 9.14618L10.0625 2.66562L10.0625 19.5313C10.0625 19.9627 9.71272 20.3125 9.28125 20.3125C8.84978 20.3125 8.5 19.9627 8.5 19.5313L8.5 2.66719L2.02118 9.14618C1.71608 9.45127 1.22142 9.45127 0.916322 9.14618C0.611225 8.84108 0.611225 8.34642 0.916322 8.04132L8.72882 0.228822L8.79428 0.170251L8.89099 0.104292L9.03748 0.0388266L9.16552 0.00851222L9.21435 0.00284648L9.29771 0.000172056C9.33083 0.000865821 9.36392 0.00365307 9.39675 0.0085338L9.28125 -3.75645e-07L9.36473 0.00440738L9.47943 0.0254244L9.52514 0.0388211L9.64337 0.0887574L9.75327 0.158597L9.83368 0.228823L17.6462 8.04132Z"
      fill="#054C2E"
    />
  </svg>
)

export default ArrowBackIcon
